import {TemplatesEnum} from "../enums/TemplatesEnum";
import {AccidentEnum} from "../enums/AccidentEnum";

export class CalcData {
  itemType: TemplatesEnum = TemplatesEnum.BICIKLO;
  accident: AccidentEnum = AccidentEnum.OPTION1;
  startDate?: string;
  purchaseDate?: string;
  itemValue?: number;
  cFirstName?: string;
  cLastName?: string;
  cAddress?: string;
  cCity?:string;
  iFirstName?: string;
  iLastName?: string;
  iAddress?: string;
  iCity?:string;
  phone?:string;
  email?: string;
  isHull?:boolean;
  hull?:boolean;
  no1?:number;
  receiveNews:any;
  receipt?: File|undefined;
  photo?:File|undefined;
}
